import React from 'react';
import { Navigate } from 'react-router-dom';

const UnauthenticatedRoute = ({ component: Component, ...rest }) => {
  const isAuthenticated = localStorage.getItem("token");
  return isAuthenticated ? <Navigate to="/dashboard" /> : <Component {...rest} />;
};

export default UnauthenticatedRoute;
